import React from 'react';
import {
  OfferButtonWrapper,
  OfferDescWrapper,
  OfferSubTitleHolder,
  OfferTermsWrapper,
  OfferTitleWrapper,
  ScrollViewStyle,
  offerDetailStyles,
} from './styledComponents';
import Button from '../../../../../../components/Button/Button';
import { TEXT_KEY, getText } from 'shared/utils/localization';
import { ASSET_KEY, assetSource } from 'shared/utils/assetSource';
import { numberWithCommas } from 'shared/utils/number';
import { BUTTON_STROKES } from 'shared/utils/buttonTextStrokes';
import { useTheme } from 'styled-components';

const OfferDetailsDescription = props => {
  const {
    rewardname,
    subtitle,
    rdesc,
    pointsneeded,
    terms,
    handlePurchase,
    isPurchaseButtonDisabled,
    onDisabledButtonClick,
    rewardCenterAssets,
  } = props;

  const { OfferDetailDescription } = useTheme();

  const applyAnchorAttributes = html =>
    html.replace(/<a\b([^>]*)>/gi, (_match, rawAttrs = '') => {
      let attrs = rawAttrs.trim();

      attrs = /\btarget\s*=/i.test(attrs)
        ? attrs.replace(/\btarget\s*=\s*(".*?"|'.*?'|[^\s>]+)/i, 'target="_blank"')
        : `${attrs} target="_blank"`.trim();

      attrs = /\brel\s*=/i.test(attrs)
        ? attrs.replace(/\brel\s*=\s*(".*?"|'.*?'|[^\s>]+)/i, 'rel="noopener noreferrer"')
        : `${attrs} rel="noopener noreferrer"`.trim();

      return `<a ${attrs}>`;
    });

  const formatDescription = text => {
    if (!text) return '';

    let formatted = text;

    formatted = formatted.replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>');

    formatted = formatted.replace(/\*(.+?)\*/g, '<em>$1</em>');
    formatted = formatted.replace(
      /\[([^\]]+)\]\(([^)]+)\)/g,
      '<a href="$2" target="_blank" rel="noopener noreferrer">$1</a>'
    );

    formatted = formatted.replace(
      /(?<!href=")(https?:\/\/[^\s<]+)/g,
      '<a href="$1" target="_blank" rel="noopener noreferrer">$1</a>'
    );

    return applyAnchorAttributes(formatted);
  };

  return (
    <ScrollViewStyle>
      <OfferTitleWrapper>
        <div className="rewardCenterGradientText OfferDetailName" data-label={rewardname}>
          {rewardname}
        </div>
      </OfferTitleWrapper>
      <OfferSubTitleHolder>
        <div className="OfferDetailSubtitle">{subtitle}</div>
      </OfferSubTitleHolder>
      <div className="offerDetailsActionContainer">
        <OfferButtonWrapper>
          <Button
            imageSource={
              isPurchaseButtonDisabled
                ? assetSource(ASSET_KEY.ROUNDED_RECT_DISABLED)
                : assetSource(ASSET_KEY.ROUNDED_RECT_PRIMARY)
            }
            imageStyle={offerDetailStyles.offerButtonImageStyle}
            containerStyle={offerDetailStyles.offerButtonContainerStyle}
            offerButtonWrapperStyle={offerDetailStyles.offerButtonWrapperStyle}
            onClick={isPurchaseButtonDisabled ? onDisabledButtonClick : handlePurchase}
            buttonIconStyle={OfferDetailDescription.ButtonIcon}
            buttonIcon={
              isPurchaseButtonDisabled
                ? rewardCenterAssets.REWARD_CENTER_LOYALTY_ICON_DISABLED
                : rewardCenterAssets.REWARD_CENTER_LOYALTY_ICON
            }
            textStroke={isPurchaseButtonDisabled ? BUTTON_STROKES.DISABLED : BUTTON_STROKES.PRIMARY}
            label={numberWithCommas(pointsneeded)}
            textStyle={OfferDetailDescription.ButtonText}
          />
        </OfferButtonWrapper>
      </div>
      <OfferDescWrapper>
        <span
          className="OfferDetailDescription"
          dangerouslySetInnerHTML={{
            __html: formatDescription(rdesc),
          }}
        />
      </OfferDescWrapper>
      <OfferTermsWrapper>
        <div className="OfferDetailTermTitle">{getText(TEXT_KEY.PURCHASE_AND_USAGE_LIMITATIONS)}</div>
        <div className="OfferDetailTerm">
          <span
            className="OfferDetailDescription"
            dangerouslySetInnerHTML={{
              __html: formatDescription(terms),
            }}
          />
        </div>
      </OfferTermsWrapper>
    </ScrollViewStyle>
  );
};

export default OfferDetailsDescription;
